export { ToPublishingPageButton } from './ToPublishingPageButton';



// WEBPACK FOOTER //
// ./src/vp-ui/components/ToPublishingPageButton/index.js